import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem } from '@mui/material';
import './CallScores.css';

const data = [
  { title: "Agenda & Strategic Communication", details: "Expand Details", score: "4/5" },
  { title: "Project Management", details: "Expand Details", score: "3/5" },
  { title: "Team Collaboration", details: "Expand Details", score: "5/5" },
  { title: "Client Interaction", details: "Expand Details", score: "4/5" },
  { title: "Market Analysis", details: "Expand Details", score: "3/5" },
  { title: "Product Development", details: "Expand Details", score: "4/5" },
  { title: "Sales Strategy", details: "Expand Details", score: "5/5" },
  { title: "Customer Support", details: "Expand Details", score: "4/5" },
  { title: "Financial Planning", details: "Expand Details", score: "3/5" }
];

const formatDetails = (text) => {
  const words = text.split(" ");
  return words.reduce((acc, word, index) => {
    if (index % 5 === 0 && index !== 0) {
      acc.push([]);
    }
    acc[acc.length - 1].push(word);
    return acc;
  }, [[]]).map(line => line.join(" ")).join("\n");
};

const CallScores = ({ scores }) => {
  const scoreEntries = scores
    ? Object.entries(scores).map(([key, value]) => ({
        title: key.replace(/_/g, " "),
        details: value.notes ? formatDetails(value.notes) : "No details provided",
        score: `${value.score}/5`,
      }))
    : [];

  return (
    <Card className="component-scores" sx={{ borderRadius: '12px', boxShadow: 'none', border: 'none' }}>
      <CardContent className="header">
        <Typography className="title">
          Call Scores
        </Typography>
      </CardContent>
      <CardContent className="content">
        <List>
          {scoreEntries.length > 0 ? (
            scoreEntries.map((item, index) => (
              <ListItem key={index} className="list-item">
                <Box className="list-box">
                  <Typography className="list-title">
                    {item.title
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ')
                      .replace(/\bAnd\b/gi, '&')}
                  </Typography>
                  <Typography className="list-score">{item.score}</Typography>
                </Box>
                <Typography className="list-details">{item.details}</Typography>
              </ListItem>
            ))
          ) : (
            <Typography className="no-scores">No scores available</Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default CallScores;
